import type { MouseEvent } from "react";

export function Star({
  on,
  onToggle,
}: {
  on: boolean;
  onToggle: () => void;
}) {
  // stopPropagation чтобы клик по звезде не уводил в карточку бумаги.
  const handle = (e: MouseEvent) => {
    e.stopPropagation();
    onToggle();
  };
  return (
    <button
      className={on ? "star on" : "star"}
      onClick={handle}
      title={on ? "Убрать из избранного" : "Добавить в избранное"}
      aria-label={on ? "Remove from favorites" : "Add to favorites"}
    >
      {on ? "★" : "☆"}
    </button>
  );
}
